export { default as IndexTableCellUuid } from './IndexTableCellUuid';
